import React from 'react';
import { TERMS_LINKS } from '@avalara/bat-apps-shared/lib/constants';
import ExternalLink from './external-link';
import { DisclaimerText } from './styled/components/cart';
const CartDisclaimerText = ({ isDisabled }) => {
    if (isDisabled) {
        return null;
    }
    return (React.createElement(DisclaimerText, null,
        React.createElement("i", null,
            "By clicking ",
            "'Submit payment'",
            " you agree that your purchase and use of the service is governed by the\u00A0",
            React.createElement(ExternalLink, { href: TERMS_LINKS.general, alwaysOpenInNewTab: true }, " terms "))));
};
export default CartDisclaimerText;
